import { render, staticRenderFns } from "./organization-survey-template.vue?vue&type=template&id=641fc724&scoped=true"
import script from "./organization-survey-template.vue?vue&type=script&lang=js"
export * from "./organization-survey-template.vue?vue&type=script&lang=js"
import style0 from "./organization-survey-template.vue?vue&type=style&index=0&id=641fc724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641fc724",
  null
  
)

export default component.exports